import type { RelatedInvoice } from '../../types/relatedInvoice'
import { getInvoiceOrDraftRoute } from '../getInvoiceOrDraftRoute'
import { getRelatedInvoiceDocumentType } from './getRelatedInvoiceDocumentType'

export const getRelatedInvoiceRoute = (relatedInvoice: RelatedInvoice): string =>
  getInvoiceOrDraftRoute({
    billingStage: relatedInvoice.billingStage,
    documentId: String(relatedInvoice.invoiceId ?? relatedInvoice.invoiceDraftId),
    documentType: getRelatedInvoiceDocumentType(relatedInvoice),
  })
